module.exports = __webpack_public_path__ + "static/media/hear.04392f11.png";